export default "/_next/static/images/new-user-badge-ca8b01b93013986d0d32c10644e67fc6.png";